const searchToggle = document.querySelector('#search-toggle');
const searchClose = document.querySelector('#search-close > button');
const searchCloseItem = document.querySelector('#search-close');
const searchForm = document.querySelector('#search-form');
const searchInput = document.querySelector('#search-input');
const menubis = document.querySelector('#menu-menu-principal');

const openSearch = () => {
  searchToggle.setAttribute('aria-expanded', 'true');
  searchForm.setAttribute('data-open', 'true');
  menubis.classList.add('header__menu--hidden');
  searchCloseItem.setAttribute('data-visible', 'true');
  searchInput.focus();
};

const closeSearch = () => {
  searchToggle.setAttribute('aria-expanded', 'false');
  searchForm.setAttribute('data-open', 'false');
  menubis.classList.remove('header__menu--hidden');
  searchCloseItem.setAttribute('data-visible', 'false');
  searchInput.blur();
  searchInput.value = '';
};

searchToggle.addEventListener('click', () => {
  const isOpen = searchToggle.getAttribute('aria-expanded') === 'true';
  const isNotEmpty = searchInput.value !== '';

  isOpen && isNotEmpty ? searchForm.submit() : openSearch();
});

searchClose.addEventListener('click', () => {
  const isVisible = searchCloseItem.getAttribute('data-visible') === 'true';

  isVisible && closeSearch();
});
